import { useCheckoutRouting } from "@/hooks/useCheckoutRouting";

interface XpfPriceProps {
  /** Montant stocké en base : toujours des francs pacifique (XPF). */
  amountXpf: number;
  className?: string;
  /** Masquer l'équivalent euro (rare : contexte déjà libellé en euro). */
  showEur?: boolean;
}

export const formatXpf = (amount: number) =>
  `${Math.round(amount).toLocaleString("fr-FR")} F CFP`;

export const formatEur = (amount: number) =>
  `${amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

/**
 * Prix d'un produit Pro : jamais de Coco.
 * Le taux XPF -> EUR vient de `app_settings.xpf_per_eur` (aucune valeur en dur).
 */
export const XpfPrice = ({ amountXpf, className = "", showEur = true }: XpfPriceProps) => {
  const { routing } = useCheckoutRouting();
  const amountEur = amountXpf / routing.xpfPerEur;

  return (
    <div className={`flex flex-col sm:flex-row sm:items-baseline gap-x-2 gap-y-0.5 flex-wrap ${className}`}>
      <span className="font-semibold text-lg whitespace-nowrap">{formatXpf(amountXpf)}</span>
      {showEur && (
        <span className="text-xs text-muted-foreground whitespace-nowrap">
          ≈ {formatEur(amountEur)}
        </span>
      )}
    </div>
  );
};

export default XpfPrice;
